import { useTranslation } from "react-i18next";
import SectionHeader from "../../../../../util/component/SectionHeader";
import CreateIntermediariesPrintout from '../sections/CreateIntermediariesPrintout';

const IntermediariesPrintoutWizard = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'intermediaries' });

    return (
        <>
            <SectionHeader title={t('printout-wizard.title')} subtitle={t('printout-wizard.subtitle')}/>
            <CreateIntermediariesPrintout/>
        </>
    )
}

export default IntermediariesPrintoutWizard;